//WE.Flow.Html.Contracts.Manifests.RoleBlacklist

export class RoleBlacklist {
    blacklist: string[] = null;
}
